import whenDomReady from 'when-dom-ready';
function initialise() {
    const copyElems = document.querySelectorAll('.js-copy-to-clipboard');
    // OnClick event to copy link buttons
    copyElems.forEach((element) => {
        element.addEventListener('click', () => {
            const copiedString = element.getAttribute('id');
            copyToClipboard(copiedString);
            element.setAttribute('data-copied', 'true');
            setTimeout(() => element.setAttribute('data-show-copied-text', 'true'), 200); // show text just a bit later
            // hide the appearance and text together
            setTimeout(() => {
                element.removeAttribute('data-copied');
                element.removeAttribute('data-show-copied-text');
            }, 2000);
        });
    });
    function copyToClipboard(str) {
        const el = document.createElement('textarea');
        el.value = str;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
    }
}
whenDomReady().then(initialise);
